import { createFeatureSelector, createSelector, createSelectorFactory } from '@ngrx/store';
import { odataParamsFactory } from '../../../models/odata-response.model';
import * as fromAdmin from '../../reducers/admin';
import * as fromBase from './admin.selectors';

export const selectAdminState = createFeatureSelector<fromAdmin.State>(fromAdmin.adminFeatureKey);

export const selectBase = createSelector(selectAdminState, state => state.base);

export const selectLoaders = createSelector(selectBase, state => state.loaders as any[]);
export const selectLoader = (name: fromAdmin.Loaders) =>
  createSelector(selectLoaders, (loaders: fromAdmin.Loaders[]) => !!((loaders || []).find(f => f === name)));

export const selectAppInfo = createSelector(selectBase, state => state.appInfo);

export const selectUploadProgress = createSelector(selectBase, state => state.uploadProgress);

export const selectDrawingMappings = createSelector(selectBase, state => state.drawingMappings);
export const selectDrawingMappingsValue = createSelector(selectBase, state => state.drawingMappings?.value || []);
export const selectDrawingMappingsTotalCount = createSelector(selectBase, state => state.drawingMappings?.['@odata.count']);
export const selectDrawingMappingsPartNumberFilterVal = createSelector(selectBase, state => state.drawingMappingPartNumberFilter);
export const selectDrawingMappingsPartNumberFilter = createSelector(selectDrawingMappingsPartNumberFilterVal, val => (val || '').length > 0 ? ` AND contains(partNumber, '${val}')` : '');
export const selectDrawingMappingsFilenameFilterVal = createSelector(selectBase, state => state.drawingMappingFilenameFilter);
export const selectDrawingMappingsFilenameFilter = createSelector(selectDrawingMappingsFilenameFilterVal, val => (val || '').length > 0 ? ` AND contains(filename, '${val}')` : '');
export const selectDrawingOdataQuery = createSelector(selectBase, selectDrawingMappingsPartNumberFilter, selectDrawingMappingsFilenameFilter, (state, partnumber, filename) => {
  return {
    ...state.drawingMappingQuery,
    filter: `${state.drawingMappingQuery.filter}${filename}${partnumber}`
  }
});
export const selectDrawingOdataPageSize = createSelector(selectDrawingOdataQuery, q => q.top);
export const selectDrawingMappingsCurrentPage = createSelector(selectDrawingOdataQuery, q => q.skip === 0 ? 1 : Math.ceil((q.skip / q.top) + 1));

export const selectFlatterFilesExistenceGraph = createSelector(selectBase, state => state.flatterFilesExistenceGraph);
export const selectActiveTab = createSelector(selectBase, base => base.activeTab);
